import cx from 'classnames';
import { VerticalAlign, BreakpointMap, Gutter, Align, RowWrapValue, Direction, RowColCount } from './types';
import {
  generateCommonRowClasses,
  generateRowGutterClasses,
  generateRowColCountClass,
  GRID_COMPONENTS_PREFIX
} from './utils';
import { ElementType, forwardRef, DetailedHTMLProps, HTMLAttributes } from 'react';

export interface IRowProps extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>, 'ref'> {
  verticalAlign?: VerticalAlign | BreakpointMap<VerticalAlign>;
  align?: Align | BreakpointMap<Align>;
  wrap?: RowWrapValue | BreakpointMap<RowWrapValue>;
  gutter?: Gutter | BreakpointMap<Gutter>;
  tag?: ElementType;
  direction?: Direction | BreakpointMap<Direction>;
  colCount?: RowColCount;
}

export const Row = forwardRef<HTMLElement, IRowProps>(
  (
    {
      verticalAlign,
      align,
      gutter,
      wrap = true,
      className,
      children,
      direction,
      tag = 'div',
      colCount = 12,
      ...restProps
    }: IRowProps,
    ref
  ) => {
    const classes = cx(
      `${GRID_COMPONENTS_PREFIX}-row`,
      generateCommonRowClasses(wrap, 'row-wrap'),
      generateCommonRowClasses(verticalAlign, 'row-align'),
      generateCommonRowClasses(align, 'row-justify'),
      generateCommonRowClasses(direction, 'row-direction'),
      generateRowGutterClasses(gutter),
      generateRowColCountClass(colCount),
      className
    );

    const Tag = tag || 'div';

    return (
      <Tag className={classes} ref={ref} {...restProps}>
        {children}
      </Tag>
    );
  }
);

Row.displayName = 'Row';
